export default "__VITE_ASSET__B67TgSdO__"